// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__Gr_OK","colMaxWidth":"Table_colMaxWidth__OHCpS"};